import { useState } from "react";
import { motion } from "framer-motion";
import { Expand } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Reveal } from "@/components/store/Reveal";
import { PAGES } from "@/constants/product";

const tilt = ["lg:-rotate-6 lg:translate-y-6", "lg:rotate-0 lg:-translate-y-4", "lg:rotate-6 lg:translate-y-6"];

const Page = ({ p, i, onOpen }) => (
  <motion.button onClick={() => onOpen(p)} whileHover={{ y: -18, rotate: 0, scale: 1.03 }} transition={{ type: "spring", stiffness: 200, damping: 18 }}
    className={`group relative mx-auto block w-[82%] max-w-[340px] text-left sm:w-full ${tilt[i]}`} data-testid={`preview-page-${i + 1}`}>
    <div className="relative overflow-hidden rounded-sm border border-white/15 shadow-[0_40px_60px_-30px_rgba(0,0,0,0.8)]">
      <img src={p.src} alt={`Example layout: ${p.title}`} className="aspect-[2/3] w-full object-cover" />
      <span className="absolute bottom-3 left-3 rounded-full bg-[var(--ink)] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--paper)]">Example layout</span>
      <span className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-[var(--paper)] text-[var(--ink)] opacity-0 transition-opacity group-hover:opacity-100"><Expand className="h-4 w-4" /></span>
    </div>
    <p className="font-display mt-5 text-2xl text-[var(--paper)]">{p.title}</p>
    <p className="mt-1 text-sm text-zinc-300">{p.text}</p>
  </motion.button>
);

export const InsidePreview = () => {
  const [open, setOpen] = useState(null);
  return (
    <section id="inside" className="bg-[var(--ink)] px-5 py-24 text-[var(--paper)] sm:px-10 sm:py-32" data-testid="inside-section">
      <div className="mx-auto max-w-[1360px]">
        <Reveal className="grid gap-6 lg:grid-cols-[1fr_0.8fr] lg:items-end">
          <h2 className="font-display text-5xl leading-[0.95] sm:text-7xl">A look <span className="italic text-[var(--sage)]">inside.</span></h2>
          <p className="text-zinc-300" data-testid="inside-disclaimer">These are example layouts that show the style of worksheet you'll work with. They're illustrations, not exact pages from the PDF.</p>
        </Reveal>
        <div className="mt-20 grid gap-16 sm:grid-cols-3 sm:gap-6 lg:gap-10">
          {PAGES.map((p, i) => <Reveal key={p.title} delay={i * 0.1}><Page p={p} i={i} onOpen={setOpen} /></Reveal>)}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={(v) => { if (!v) setOpen(null); }}>
        <DialogContent className="max-h-[92vh] max-w-xl overflow-y-auto border-black/20 bg-[var(--paper)] p-4" data-testid="preview-dialog">
          <DialogTitle className="font-display text-2xl">{open?.title}</DialogTitle>
          <DialogDescription className="text-[var(--muted)]">Example layout · illustrative preview</DialogDescription>
          {open && <img src={open.src} alt={`Example layout: ${open.title}`} className="w-full rounded-sm border border-black/15" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
